import { ViewLoaderService } from '@addins/core/menus';
import { PanelToolBase } from '@addins/core/panel';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { LayoutService } from '@services/layout/layout.service';
import { StatusChangeViewPosition } from '@services/settings';
import { StatusViewService } from '@services/status/status-view/status-view.service';
import { ViewSelectorService } from '@services/view-selector/view-selector.service';

@Component({
  selector: 'app-rows',
  templateUrl: './rows.component.html',
  styleUrls: ['./rows.component.scss']
})
export class RowsComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('view') view: IonNav;

  topLayoutSplitterNeeded: boolean = false;
  topLayoutMaxHeight: number = 35;
  topLayoutMinHeight: number = 10;

  get mainLayout(): string[] {
    return this.layoutService.mainLayout();
  }

  statusPanelTool: PanelToolBase = null;
  readonly statusPositionTop: StatusChangeViewPosition = StatusChangeViewPosition.Top;
  readonly statusPositionRight: StatusChangeViewPosition = StatusChangeViewPosition.Right;
  get statusViewPosition() {
    return this.statusViewService.statusViewPosition;
  }

  constructor(
    private viewLoaderService: ViewLoaderService,
    private layoutService: LayoutService,
    private viewSelectorService: ViewSelectorService,
    private statusViewService: StatusViewService
  ) {}

  ngOnInit() {
    this.statusPanelTool = this.statusViewService.statusPanelTool;
  }

  ngAfterViewInit() {
    this.viewLoaderService.initialize(this.view, this.viewSelectorService.getView(this.layoutService.entryPage()).element);
  }

  setTopLayoutSplitterNeeded(isNeeded: boolean) {
    setTimeout(() => {
      this.topLayoutSplitterNeeded = isNeeded;
    });
  }

  ngOnDestroy() {
    this.viewLoaderService.reset();
  }
}
